import { createFileRoute } from "@tanstack/react-router";
import type { ContradictionPair } from "@/api/types";
import contradictions from "@/fixtures/contradictions.json";
import { ContradictionBrowse } from "@/components/contradiction/ContradictionBrowse";

const PAIRS = contradictions as Record<string, ContradictionPair>;

export const Route = createFileRoute("/contradictions/")({
  component: ContradictionsBrowsePage,
});

function ContradictionsBrowsePage() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-10 lg:px-10">
      <ContradictionBrowse pairs={Object.values(PAIRS)} />
    </div>
  );
}
